import { BrowserStorageStoreSettings } from '../store.types';
import { createStore } from './create-store';

export const createSessionStorageStore = <State extends object, Action extends string>({
    key,
    initialState,
    actions,
    initAction,
}: BrowserStorageStoreSettings<State, Action>) => {
    const store = createStore<State, Action>({
        initialState,
        actions,
    });

    function updateStore(data: State) {
        return store.dispatch(initAction, data);
    }

    function get(): State | undefined {
        const value = sessionStorage.getItem(key);
        if (!value) return;

        return JSON.parse(value);
    }

    function set(value: State) {
        try {
            const serializedState = JSON.stringify(value);

            sessionStorage.setItem(key, serializedState);
        } catch (error) {
            console.log('Error in sessionStorage.setItem', error);
        }
    }

    store.subscribe((data) => set(data));

    const data = get();
    if (data) updateStore(data);

    return { get, set, ...store };
};
